export default __webpack_public_path__ + "static/media/image-study-admin-w@3x.d5143c10.webp";